export default "__VITE_ASSET__9nPQbMkg__"